import * as React from 'react';
import { Select as AntdSelect } from 'antd';

import { FormItem, getDefaultFormItemOptions, IFormItem } from './form-item';
import { Skeleton } from 'ui-lib/components/loading';
import css from './form-item.css';

export interface IMultipleSelectItemProps extends IFormItem {
    placeholder?: string;
    dataSource: { value: number | string, label: string }[];
    selectedValue?: { value: number | string, label: string }[] | number[] | string[];
    onChange?: (value, option) => void;
    filterOption?: (inputValue, option) => boolean;
    loading?: boolean;
}

export const MultipleSelectFormItem = (props: IMultipleSelectItemProps) => {
    const formItemProps = getDefaultFormItemOptions(props);
    formItemProps.initialValue = props.selectedValue;
    return (
        <FormItem
            code={props.code}
            {...formItemProps}
            initialValue={props.selectedValue}
            child={
                <Skeleton
                    loading={props.loading}
                    noOfRows={1}
                    title={{ className: css['select-form-item-skeleton-default'] }}
                >
                    <AntdSelect
                        mode='multiple'
                        allowClear={true}
                        loading={props.loading}
                        placeholder={props.placeholder}
                        onChange={props.onChange}
                        value={props.selectedValue}
                        disabled={props.disabled}
                        filterOption={props.filterOption}
                    >
                        {props.dataSource.map((item) => (
                            <AntdSelect.Option key={item.value} value={item.value}>
                                {item.label}
                            </AntdSelect.Option>
                        ))}
                    </AntdSelect>
                </Skeleton>
            }
        />
    );
};

